let hasScrolled = false;

function initLogoSlider() {
    var logoSlider = new Swiper('[data-logo-slider]', {
        loop: true,
        slidesPerView: 3,
        centeredSlides: true,
        spaceBetween: 100,
        centeredSlidesBounds: true,
        autoplay: {
            delay: 3000,
            pauseOnMouseEnter: true
        },
        breakpoints: {
            0: {
                spaceBetween: 50
            },
            990: {
                spaceBetween: 100
            }
          }
      });
}

window.addEventListener('scroll', function () {
    if (hasScrolled) return;
    if (window.scrollY > 100) {
        loadCSS(swiperCSS);
        loadJS(swiperJS)
            .then(() => initLogoSlider())
            .catch(error => console.error(error));
        hasScrolled = true;
    }
});